/** 役割の欄（一覧の行と契約情報で同じ）。 */
export interface TenantRole {
    readonly isContractor: boolean;
    readonly isAdmin: boolean;
}

/**
 * 役割の札の色（契約者・管理者・一般）。<b>文言はサーバが作る</b>（roleLabel）。ここは色を選ぶだけ。
 */
export const roleBadge = (role: TenantRole): string => {
    if (role.isContractor) {
        return "badge-brand";
    }
    return role.isAdmin ? "badge-info" : "badge-muted";
};
